/**
 * @generated SignedSource<<f7e152d0e0807febca708f22d57baf33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProcedureFlags = "BOOKING_CROSS_SELL" | "COMBO" | "DISABLE_PRICE_MODIFIERS" | "FEATURED" | "FEMALE" | "LIPO_ADDON" | "LOCAL_ANESTHESIA_ELIGIBLE" | "MALE" | "MASSIVE_WEIGHT_LOSS" | "NON_SURGICAL" | "SPECIAL" | "TRANS" | "%future added value";
export type QuoteAddOn = "ACCESSORIES" | "SEVEN_DAY_PACKAGE" | "THREE_DAY_PACKAGE" | "%future added value";
export type SimpleStatus = "APPROVED_BY_SURGEON" | "BMI_TOO_HIGH" | "BOOKED" | "CANCELLED" | "DELETE_PENDING" | "ESTIMATE_ACCEPTED" | "ESTIMATE_SENT" | "INCOMPLETE" | "LIKELY_TO_BOOK" | "NEW_LEAD" | "NOT_MEDICALLY_FIT" | "PATIENT_DECLINED" | "REJECTED_BY_SURGEON" | "REQUESTED_SURGEON_REVIEW" | "SALES_REVIEW" | "SEND_AI_QUOTE" | "UPDATED" | "%future added value";
export type SpecialBadgeColor = "GOLD" | "GREEN" | "RED" | "%future added value";
export type QuoteProviderWithQuoteQuery$variables = {
  incomingQuoteId: string;
};
export type QuoteProviderWithQuoteQuery$data = {
  readonly businessLocations: ReadonlyArray<{
    readonly id: string;
    readonly image: string;
    readonly name: string;
  } | null> | null;
  readonly procedureTypes: ReadonlyArray<{
    readonly id: string;
    readonly image: string | null;
    readonly isInternal: boolean | null;
    readonly name: string;
    readonly position: number | null;
    readonly useForSimplifiedFlow: boolean | null;
  } | null> | null;
  readonly procedures: ReadonlyArray<{
    readonly activeEndsAt: any | null;
    readonly activeStartsAt: any | null;
    readonly beforeAfterImages: ReadonlyArray<string | null> | null;
    readonly description: string | null;
    readonly facts: ReadonlyArray<{
      readonly label: string;
      readonly labelEs: string | null;
      readonly value: string;
      readonly valueEs: string | null;
    } | null> | null;
    readonly flags: ReadonlyArray<ProcedureFlags> | null;
    readonly heroImage: string | null;
    readonly id: string;
    readonly image: string | null;
    readonly incompatibleProcedures: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly isInternal: boolean | null;
    readonly maleImage: string | null;
    readonly marketingName: string | null;
    readonly marketingNameEs: string | null;
    readonly name: string;
    readonly popularity: {
      readonly count: number | null;
      readonly tier: number | null;
    } | null;
    readonly position: number | null;
    readonly price: number | null;
    readonly prices: ReadonlyArray<{
      readonly id: string;
      readonly price: number | null;
      readonly surgeon: {
        readonly id: string;
        readonly name: string;
      } | null;
    }> | null;
    readonly procedureSlug: string;
    readonly procedureTypes: ReadonlyArray<{
      readonly id: string;
      readonly image: string | null;
      readonly name: string;
      readonly useForSimplifiedFlow: boolean | null;
    }> | null;
    readonly specialBadgeColor: SpecialBadgeColor | null;
    readonly specialBadgeText: string | null;
    readonly specialBadgeTextEs: string | null;
    readonly specialOfProcedureId: string | null;
    readonly subtitle: string | null;
    readonly subtitleEs: string | null;
    readonly tagline: string | null;
    readonly taglineEs: string | null;
  } | null> | null;
  readonly quote: {
    readonly acceptedHipaa: boolean | null;
    readonly accessTokenStatus: string | null;
    readonly addOns: ReadonlyArray<QuoteAddOn> | null;
    readonly age: number | null;
    readonly budget: string | null;
    readonly cherryFinancingFile: {
      readonly name: string | null;
      readonly response: {
        readonly url: string;
      };
      readonly uid: string | null;
    } | null;
    readonly email: string;
    readonly fileList: ReadonlyArray<{
      readonly name: string | null;
      readonly response: {
        readonly url: string;
      };
      readonly uid: string | null;
    }> | null;
    readonly heightFt: number | null;
    readonly heightIn: number | null;
    readonly id: string;
    readonly language: string | null;
    readonly lastName: string | null;
    readonly medicalConditions: ReadonlyArray<string> | null;
    readonly name: string;
    readonly optInText: boolean | null;
    readonly patient: {
      readonly id: string;
    } | null;
    readonly patientNotes: string | null;
    readonly patientReadiness: string | null;
    readonly phone: string;
    readonly priorCosmeticSurgery: boolean | null;
    readonly procedureDescription: string | null;
    readonly selectedLocation: {
      readonly id: string;
    } | null;
    readonly selectedProcedureTypes: ReadonlyArray<{
      readonly id: string;
    }> | null;
    readonly selectedProceduresV2: ReadonlyArray<{
      readonly id: string;
    }> | null;
    readonly selectedSurgeon: {
      readonly id: string;
    } | null;
    readonly simpleStatus: SimpleStatus | null;
    readonly smoker: boolean | null;
    readonly status: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly surgeryDateRange: string | null;
    readonly weight: number | null;
    readonly willingToTravel: string | null;
    readonly zipCode: string;
  } | null;
  readonly surgeons: ReadonlyArray<{
    readonly basePrice: number | null;
    readonly businessLocations: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly daysUntilAvailable: number | null;
    readonly id: string;
    readonly image: string;
    readonly name: string;
    readonly nickname: string | null;
  } | null> | null;
};
export type QuoteProviderWithQuoteQuery = {
  response: QuoteProviderWithQuoteQuery$data;
  variables: QuoteProviderWithQuoteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "incomingQuoteId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternal",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useForSimplifiedFlow",
  "storageKey": null
},
v9 = [
  (v1/*: any*/)
],
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uid",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "FileResponse",
    "kind": "LinkedField",
    "name": "response",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Surgeon",
    "kind": "LinkedField",
    "name": "surgeons",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "basePrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "daysUntilAvailable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nickname",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BusinessLocation",
        "kind": "LinkedField",
        "name": "businessLocations",
        "plural": true,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "includeShadowed",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "isDiscontinued",
        "value": false
      },
      {
        "kind": "Literal",
        "name": "isInternal",
        "value": false
      }
    ],
    "concreteType": "Procedure",
    "kind": "LinkedField",
    "name": "procedures",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingNameEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maleImage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "procedureSlug",
        "storageKey": null
      },
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flags",
        "storageKey": null
      },
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeStartsAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeEndsAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialBadgeText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialBadgeTextEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialBadgeColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "specialOfProcedureId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Procedure",
        "kind": "LinkedField",
        "name": "incompatibleProcedures",
        "plural": true,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurgeonProcedure",
        "kind": "LinkedField",
        "name": "prices",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Surgeon",
            "kind": "LinkedField",
            "name": "surgeon",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcedureType",
        "kind": "LinkedField",
        "name": "procedureTypes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tagline",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taglineEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subtitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subtitleEs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcedureFact",
        "kind": "LinkedField",
        "name": "facts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "labelEs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "valueEs",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "beforeAfterImages",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heroImage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcedurePopularity",
        "kind": "LinkedField",
        "name": "popularity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "procedures(includeShadowed:true,isDiscontinued:false,isInternal:false)"
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProcedureType",
    "kind": "LinkedField",
    "name": "procedureTypes",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BusinessLocation",
    "kind": "LinkedField",
    "name": "businessLocations",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "incomingQuoteId"
      }
    ],
    "concreteType": "Quote",
    "kind": "LinkedField",
    "name": "quote",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "simpleStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessTokenStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patient",
        "plural": false,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Status",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zipCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "weight",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heightFt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "heightIn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "age",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "acceptedHipaa",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priorCosmeticSurgery",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "smoker",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "procedureDescription",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "patientReadiness",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "surgeryDateRange",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "budget",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "willingToTravel",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "patientNotes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addOns",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "medicalConditions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optInText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "fileList",
        "plural": true,
        "selections": (v10/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "cherryFinancingFile",
        "plural": false,
        "selections": (v10/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BusinessLocation",
        "kind": "LinkedField",
        "name": "selectedLocation",
        "plural": false,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Procedure",
        "kind": "LinkedField",
        "name": "selectedProceduresV2",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProcedureType",
        "kind": "LinkedField",
        "name": "selectedProcedureTypes",
        "plural": true,
        "selections": (v9/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Surgeon",
        "kind": "LinkedField",
        "name": "selectedSurgeon",
        "plural": false,
        "selections": (v9/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderWithQuoteQuery",
    "selections": (v11/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteProviderWithQuoteQuery",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "2e5acd738a4d448803845e045ea830c7",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderWithQuoteQuery",
    "operationKind": "query",
    "text": "query QuoteProviderWithQuoteQuery(\n  $incomingQuoteId: ID!\n) {\n  surgeons {\n    id\n    name\n    image\n    basePrice\n    daysUntilAvailable\n    nickname\n    businessLocations {\n      id\n      name\n    }\n  }\n  procedures(isInternal: false, isDiscontinued: false, includeShadowed: true) {\n    id\n    name\n    marketingName\n    marketingNameEs\n    description\n    image\n    maleImage\n    procedureSlug\n    price\n    flags\n    isInternal\n    position\n    activeStartsAt\n    activeEndsAt\n    specialBadgeText\n    specialBadgeTextEs\n    specialBadgeColor\n    specialOfProcedureId\n    incompatibleProcedures {\n      id\n      name\n    }\n    prices {\n      id\n      price\n      surgeon {\n        id\n        name\n      }\n    }\n    procedureTypes {\n      id\n      name\n      image\n      useForSimplifiedFlow\n    }\n    tagline\n    taglineEs\n    subtitle\n    subtitleEs\n    facts {\n      label\n      labelEs\n      value\n      valueEs\n    }\n    beforeAfterImages\n    heroImage\n    popularity {\n      tier\n      count\n    }\n  }\n  procedureTypes {\n    id\n    name\n    image\n    isInternal\n    useForSimplifiedFlow\n    position\n  }\n  businessLocations {\n    id\n    name\n    image\n  }\n  quote(id: $incomingQuoteId) {\n    id\n    simpleStatus\n    accessTokenStatus\n    patient {\n      id\n    }\n    status {\n      id\n      name\n    }\n    name\n    lastName\n    email\n    phone\n    zipCode\n    weight\n    heightFt\n    heightIn\n    age\n    acceptedHipaa\n    priorCosmeticSurgery\n    smoker\n    procedureDescription\n    patientReadiness\n    surgeryDateRange\n    budget\n    willingToTravel\n    patientNotes\n    addOns\n    medicalConditions\n    optInText\n    language\n    fileList {\n      uid\n      name\n      response {\n        url\n      }\n    }\n    cherryFinancingFile {\n      uid\n      name\n      response {\n        url\n      }\n    }\n    selectedLocation {\n      id\n    }\n    selectedProceduresV2 {\n      id\n    }\n    selectedProcedureTypes {\n      id\n    }\n    selectedSurgeon {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "57980813033d0f3930906669e5ff2129";

export default node;
